<mat-form-field
        [floatLabel]="input.floatLabel"
        [appearance]="input.appearance"
        class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <textarea
            #textAreaElement
            type="text"
            matInput
            (blur)="blurEvent($event)"
            [attr.maxlength]="input.maxChars ? input.maxChars : null"
            [required]="input.required"
            [formControl]="input.control"
            [aria-describedby]="textAreaElement.id + editPromptSuffix"
            [placeholder]="input.placeholder"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="input.rows"
            (blur)="blurEvent($event)"
            (focus)="focusEvent($event)"
    ></textarea>
    <div class="has-max-chars" *ngIf="hasMaxChars">{{input.control?.value?.length ? input.control.value.length : 0}} / {{input.maxChars}}</div>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>
